module.exports = __webpack_public_path__ + "img/CNN.5be72d11.png";